import { render, staticRenderFns } from "./ProjectedInventoryGraph.vue?vue&type=template&id=6824a0f6&"
import script from "./ProjectedInventoryGraph.vue?vue&type=script&lang=ts&"
export * from "./ProjectedInventoryGraph.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectedInventoryGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports